import type { ModelDuplicateButtonProps } from "./model-duplicate-button.type";

import { useAuthorization } from "@/modules/authorization";

import ModelDuplicateButton from "./model-duplicate-button.component";

const ModelDuplicateButtonWrapper = (props: ModelDuplicateButtonProps) => {
  const { canCreateModel } = useAuthorization();

  if (!canCreateModel(props.modelKey)) return null;

  return <ModelDuplicateButton {...props} />;
};

export default ModelDuplicateButtonWrapper;
